import { useEffect, useState } from 'react';

function useMinWidth(px) {
    const query = `(min-width: ${px}px)`;
    const [matches, setMatches] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(query).matches
    );

    useEffect(() => {
        const mq = window.matchMedia(query);
        const onChange = (e) => setMatches(e.matches);
        setMatches(mq.matches);
        mq.addEventListener('change', onChange);
        return () => mq.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}

/**
 * v7 .modal-footer — Back left; Save & continue later + Next grouped right; auto-width buttons.
 */
const WizardStepFooter = ({ hint, back, primary, tertiary }) => {
    const isRow = useMinWidth(768);

    return (
        <div className="wizard-step-footer-wrap">
            {hint}
            <div className={`wizard-step-footer${isRow ? '' : ' wizard-step-footer-stacked'}`}>
                <div className="wizard-step-footer-back">{back}</div>
                {(tertiary || primary) && (
                    <div className="wizard-step-footer-actions">
                        {tertiary}
                        {primary}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WizardStepFooter;
